/* global Promise, window, document, URL, Blob */
import * as R from 'ramda';


export default function ImportDocumentDialogController(
  alerts,
  importDataService,
  importMappingDialog,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialogClick = handleCloseDialogClick;
  vm.handleImportFileAdd = handleImportFileAdd;
  vm.handleDownloadTemplateClick = handleDownloadTemplateClick;
  vm.handleFormSubmit = handleFormSubmit;

  vm.file = {};
  vm.progress = 0;

  /** *************************************************
   * Event Handlers
   */

  function handleCloseDialogClick() {
    return ssDialogService.hide(ssDialogService.dialogs.global.importDocumentDialog);
  }

  // eslint-disable-next-line no-unused-vars
  function handleImportFileAdd($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {
    vm.progress = 0;
  }

  function handleDownloadTemplateClick() {
    return importDataService.getImportTemplateFile(vm.importTypeId, vm.entityId)
      .then((response) => {
        const contentType = response.headers('Content-Type');
        const contentDisposition = response.headers('Content-Disposition');

        if (!R.isNil(contentDisposition)) {
          // const matches = /filename="(.*?)"/g.exec(contentDisposition);
          const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/g.exec(contentDisposition);
          vm.fileName = matches && matches.length > 1 ? matches[1] : null;
          vm.fileName = vm.fileName.split('"').join('');
        }
        const blob = new Blob(
          [response.data],
          { type: contentType, }
        );
        // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, vm.fileName);
        } else {
          const anchor = document.createElement('a');
          document.body.appendChild(anchor);
          anchor.setAttribute('type', 'hidden');

          anchor.href = URL.createObjectURL(blob);
          anchor.download = vm.fileName;
          anchor.target = '_self';
          anchor.click();
        }
      });
  }

  function handleFormSubmit(form) {
    if (!_isValid(form)) {
      return Promise.reject();
    }
    loaderService.showViewLoader = true;
    return importDataService.uploadnStageFile(vm.customerId, vm.importTypeId, vm.entityId, vm.file)
      .then((response) => {
        loaderService.showViewLoader = false;
        if (response.status === 201) {
          const importSet = response.data[0];
          if (!R.isNil(importSet.importSetId)) {
            alerts.success(`Import file ${vm.fileName} is staged successfully.`);
            _displayMappingsDialog(importSet);
            handleCloseDialogClick();
          } else {
            alerts.error(`Error occurred while staging ${vm.fileName} file.`);
          }
          return Promise.resolve();
        }
        alerts.error(`Error occurred while uploading ${vm.fileName} file.`);
        return Promise.reject();
      }).catch(() => {
        // eslint-disable-next-line max-len
        alerts.error('There was an error processing the CSV file. Please check the file and make sure that there are no blank headings.');
        loaderService.showViewLoader = false;
      });
  }

  /** *************************************************
   * Private Functions
   */

  function _displayMappingsDialog(importSet) {
    ssDialogService.dialogs.global.importMappingsDialog = ssDialogService.alert(
      importMappingDialog.getOptions({
        customerId: vm.customerId,
        importSet,
        title: vm.title,
        refreshCallBack: vm.refreshCallBack,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.global.importMappingsDialog);
  }

  function _isValid(form) {
    let isValid = true;

    if (form.$invalid) {
      isValid = false;
    }

    if ((vm.file === null) || (!vm.file.name.endsWith('.csv'))) {
      isValid = false;
      alerts.error('The imported document must be a .csv file. Please check the file and try again.');
    }

    return isValid;
  }
}

ImportDocumentDialogController.$inject = [
  'alerts',
  'importDataService',
  'importMappingDialog',
  'loaderService',
  'ssDialogService'
];
